export class AuthMember {
    id: number;

    initials: string;
    prefix: string;
    name: string;
    formatted_name: string;
    email: string;
    barcode: string;
    date_of_birth: string;

    picture: {
        avatar: string;
        thumbnail: string;
        original: string;
        status: string;
    };

    household: {
        id: number;
        prefix: string;
        name: string;
        email: string;
        position_in_waitinglist?: number;
    };
    
    barcode_members: {
        id: number;

        initials: string;
        prefix: string;
        name: string;
        formatted_name: string;
        email: string;
        barcode: string;
        date_of_birth: string;
    
        picture: {
            avatar: string;
            thumbnail: string;
            original: string;
            status: string;
        };

        is_volunteer: boolean;
        is_lifeguard: boolean;
        is_coordinator: boolean;
        administrative_exemption: boolean;
        is_extern: boolean;
    }[];
    
    permissions?: string[];

    is_main: boolean;

    is_waitinglist: boolean;
    is_volunteer: boolean;
    is_lifeguard: boolean;
    is_coordinator: boolean;
    administrative_exemption: boolean;

    access_introcard_test: boolean;
    can_update_horeca_open: boolean;
}
